import type { ChannelT } from '@vs-shop/schemas/tenant/channel';

import { getDefaultChannel } from './channel';
import { getChannelProfile } from './channelProfile';

import type { TenantIdentity } from '@vs-shop/engine/config/tenant';

/** Derives the full tenant identity of one channel from its channel profile. */
export const getTenantIdentity = (channel: ChannelT): TenantIdentity => {
  const { locale, currency, host } = getChannelProfile(channel);

  return { channel, locale, currency, host };
};

/**
 * App-shell accessor for the build-time channel. Routes and containers call this at
 * the edge and pass the result into the parameterized engine leaf functions; the
 * engine itself never reads the tenant environment.
 */
export const getDefaultTenantIdentity = (): TenantIdentity =>
  getTenantIdentity(getDefaultChannel());
